import { fetchResource } from "./utils";

export const getSearch = (query: string) => {
  return fetchResource("/search", {
    queryParams: { q: query, limit: 10, "limit-news": 30 },
  });
};
